/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mGift.vue?vue&type=template&id=343a7be0"
import script from "./mGift.vue?vue&type=script&lang=js"
export * from "./mGift.vue?vue&type=script&lang=js"
import style0 from "./mGift.vue?vue&type=style&index=0&id=343a7be0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports